(() => {
  'use strict';
  // Pixel-distance loops: no finite timer, class reset, or viewport-based speed.
  window.PDSShippingTicker?.destroy();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const lifecycle = new AbortController();
  function init(root) {
    root.querySelectorAll('[data-pds-shipping]').forEach(bar => {
      if (instances.has(bar)) return;
      const track = bar.querySelector('.pds-shipping__track');
      const group = bar.querySelector('.pds-shipping__group');
      if (!track || !group || !track.animate) return;
      const events = new AbortController();
      let animation = null, distance = 0, offset = 0, frame = 0;
      const speed = parseFloat(getComputedStyle(bar).getPropertyValue('--pds-ticker-speed')) || 60;
      function measure() {
        frame = 0;
        if (!bar.isConnected) { destroy(); return; }
        if (animation && distance) offset = ((Number(animation.currentTime) || 0) * speed / 1000) % distance;
        const fallback = bar.querySelector('.pds-shipping__message');
        if (fallback) fallback.tabIndex = preference.matches ? 0 : -1;
        if (preference.matches) {
          animation?.cancel(); animation = null;
          bar.dataset.motion = 'off';
          return;
        }
        bar.dataset.motion = 'on';
        const next = group.getBoundingClientRect().width;
        if (!next) return;
        if (!animation || Math.abs(next - distance) > .1) {
          animation?.cancel();
          distance = next;
          offset %= distance;
          animation = track.animate([
            { transform: 'translate3d(0,0,0)' },
            { transform: `translate3d(${-distance}px,0,0)` }
          ], { duration: distance / speed * 1000, iterations: Infinity, easing: 'linear' });
          animation.currentTime = offset / speed * 1000;
        }
        bar.dataset.ready = 'true';
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
      function listen(target, type, fn) { target.addEventListener(type, fn, { signal: events.signal }); }
      listen(preference, 'change', measure);
      const observer = new ResizeObserver(schedule);
      observer.observe(bar); observer.observe(group);
      if (document.fonts) {
        document.fonts.ready.then(() => { if (!events.signal.aborted) schedule(); });
        listen(document.fonts, 'loadingdone', schedule);
      }
      function destroy() {
        events.abort(); observer.disconnect(); cancelAnimationFrame(frame);
        animation?.cancel(); bar.dataset.motion = 'off';
        delete bar.dataset.ready; instances.delete(bar);
      }
      instances.set(bar, destroy);
      measure();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target), { signal: lifecycle.signal });
  document.addEventListener('shopify:section:unload', e => {
    for (const [bar, destroy] of instances) if (e.target.contains(bar)) destroy();
  }, { signal: lifecycle.signal });
  window.PDSShippingTicker = { destroy() { lifecycle.abort(); for (const destroy of instances.values()) destroy(); } };
})();
